import { RootState } from '@/shared/store'

import { attributesAdapter } from './attributesAdapters'
import { AttributeTypeEnum } from './models/Attribute'

export const attributesSelectors = attributesAdapter.getSelectors<RootState>(
  (state) => state.attributes,
)

export const selectOrderAttributes = (state: RootState) => {
  return attributesSelectors.selectAll(state).filter(
    (attribute) => attribute.attributeType === AttributeTypeEnum.Order,
  )
}

export const selectVehicleAttributes = (state: RootState) => {
  return attributesSelectors.selectAll(state).filter(
    (attribute) => attribute.attributeType === AttributeTypeEnum.Vehicle,
  )
}